const config = {
    apiKey: 'AIzaSyA8_XP2HaXzVrrise9Px4fdXXVW0BsuqF0',
    authDomain: 'necessito-7cb29.firebaseapp.com',
    databaseURL: 'https://necessito-7cb29.firebaseio.com',
    projectId: 'necessito-7cb29',
    storageBucket: 'necessito-7cb29.appspot.com',
    messagingSenderId: 'YOUR_MESSAGING_SEND_ID' 
}

export { config }


// WEBPACK FOOTER //
// ./src/firebaseSecret.js